export default {
  namespaced: true,

  state: {
    appType: null,
  },

  getters: {
    isWidget: ({ appType }) => false,
  },

  mutations: {
    mutateAppType(state, appType) {
      state.appType = appType;
    },
  },

  actions: {
    setAppType({ commit, state }, appType) {
      if (state.appType) {
        return;
      }

      commit('mutateAppType', appType);
    },
  },
};
